import React from "react";
import SurfacePage from "../../Design/Surfaces/SurfacePage";
import IconesDocuments from "../../Design/Icones/IconesDocuments";

import {
  Button,
  Divider,
  Card,
  CardContent,
  Typography,
  Box,
} from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import GetAppIcon from "@material-ui/icons/GetApp";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { makeStyles } from "@material-ui/core/styles";


const volet1 = `${process.env.PUBLIC_URL}/pdf/Attestation_CS_volet1.pdf`;
const volet2 = `${process.env.PUBLIC_URL}/pdf/Attestation_CS_volet2.pdf`;


const useStyles = makeStyles((theme) => ({
  page: {
    maxWidth: 980,
    margin: "0 auto",
    paddingBottom: theme.spacing(4),
  },
  titrePage: {
    margin: 0,
    fontSize: "2.2rem",
    fontWeight: 500,
    letterSpacing: "0.02em",
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    color: "#555",
    marginTop: theme.spacing(1),
    maxWidth: 900,
    lineHeight: 1.5,
  },
  card: {
    marginTop: theme.spacing(2),
    borderRadius: 12,
  },
  infoBox: {
    display: "flex",
    gap: theme.spacing(1.5),
    alignItems: "flex-start",
    backgroundColor: "#EEF6FF",
    border: "1px solid #D6E8FF",
    borderRadius: 12,
    padding: theme.spacing(2),
  },
  infoIcon: {
    marginTop: 2,
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 700,
  },
  actions: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
  btn: {
    textTransform: "none",
    borderRadius: 10,
    padding: theme.spacing(1.2, 2),
  },
  btnFull: {
    width: "100%",
    justifyContent: "flex-start",
  },
  smallNote: {
    marginTop: theme.spacing(1),
    color: "#666",
    fontSize: "0.9rem",
    lineHeight: 1.4,
  },
}));

export default function PageCaisseSecurisee() {
  const classes = useStyles();

  return (
    <SurfacePage>
      <div className={classes.page}>
        <div className={classes.header}>
          <h1 className={classes.titrePage}>Caisse sécurisée</h1>


          <Typography className={classes.subtitle}>
            Informations et documents liés aux obligations de conformité des
            logiciels de caisse (attestations, liens utiles et ressources).
          </Typography>
        </div>

        <div className={classes.infoBox}>
          <InfoOutlinedIcon className={classes.infoIcon} />
          <div>
            <Typography variant="body1">
              Même si SINOBI respecte les principes d’inaltérabilité,
              sécurisation, conservation et archivage des factures, AJB Services
              EURL ne dispose pas d’une certification NF525 (coût trop élevé).
            </Typography>
            <Typography className={classes.smallNote}>
              Si vous changez de logiciel, prenez le temps de vérifier que votre
              futur logiciel est bien certifié. La liste des logiciels certifiés
              est consultable via le moteur ci-dessous.
            </Typography>
          </div>
        </div>

        <Card className={classes.card} elevation={2}>
          <CardContent>
            <Typography variant="h6" className={classes.sectionTitle}>
              Liens utiles
            </Typography>

            <Button
              className={`${classes.btn} ${classes.btnFull}`}
              variant="contained"
              href="https://certificates.infocert.org/"
              target="_blank"
              rel="noreferrer"
              startIcon={<OpenInNewIcon />}
            >
              Moteur de recherche des certificats (InfoCert)
            </Button>

            <Divider style={{ margin: "18px 0" }} />

            <Typography variant="h6" className={classes.sectionTitle}>
              Attestations d’autocertification (PDF)
            </Typography>

            <Typography className={classes.smallNote}>
              Vous trouverez ci-dessous les deux volets imprimables :
              <br />• Volet 1 : partie éditeur / intégrateur
              <br />• Volet 2 : partie entreprise utilisatrice
            </Typography>

            <Box className={classes.actions}>
              <Button
                className={`${classes.btn} ${classes.btnFull}`}
                variant="contained"
                color="primary"
                href={volet1}
                target="_blank"
                rel="noreferrer"
                startIcon={<GetAppIcon />}
              >
                Télécharger / ouvrir — Attestation volet 1
              </Button>

              <Button
                className={`${classes.btn} ${classes.btnFull}`}
                variant="contained"
                color="primary"
                href={volet2}
                target="_blank"
                rel="noreferrer"
                startIcon={<GetAppIcon />}
              >
                Télécharger / ouvrir — Attestation volet 2
              </Button>
            </Box>
          </CardContent>
        </Card>
      </div>
    </SurfacePage>
  );
}
